<template>
    <div>
        <div v-if="subcampaign[0].value != 'none'" class="sub-campaign">
            <div class="txt-size">
                Color :
            </div>
            <div v-for="(item, index) in subcampaign" :key="index" class="sub-campaign-list">
                <div class="sub-campaign-item" @click="onSelectSubCampaign(item, index)"
                :class="[activeItem == index ? 'active' : '']">
                    <span class="text-uppercase">{{item.name}}</span>
                </div>
            </div>
        </div>
        <div class="sub-item" v-if="subitems.length > 0">
            <div class="txt-size">
                Size :
            </div>
            <div v-for="(item, index) in subitems" :key="index" class="sub-campaign-list">
                <div class="sub-campaign-item" @click="onSelectSubItem(item, index)"
                :class="[activeSubItem == index ? 'active' : '']">
                    Size : <span class="text-uppercase">{{item.name}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {array} subcampaign (required) Sub-campaign.
 * Event
 * @event changeColor Change selected item and setup size dropdown.
 * @event changeSize Change selected item.
 * @event updateSelectedCampaignInfo Update information back to parent component.
 */
export default {
    name: 'SubCampaign',
    props: {
        lbl: Object,
        locale: Number,
        subcampaign: Array,
    },
    data: function () {
        return {
            activeItem: null,
            subitems: [],
            activeSubItem: null
        };
    },
    mounted: function () {
        this.onSelectSubCampaign(this.subcampaign[0], 0)
    },
    methods: {
        //Event
        onSelectSubCampaign: function(item, index) {
            this.subitems = []
            this.activeItem = index;
            if(item.subitems.length > 0 && item.subitems[0].value != 'none') {
                this.activeSubItem = 0
                this.subitems = item.subitems;
                this.$emit('onChangeSubCampaign', this.subitems[0]);
            } else {
                this.$emit('onChangeSubCampaign', item);
            }
        },
        onSelectSubItem: function(item, index) {
            this.activeSubItem = index;
            this.$emit('onChangeSubCampaign', item);
        }
        //End Event
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
    .sub-campaign{
        display: flex;
        flex-wrap: wrap;
    }
    .sub-item{
        display: flex;
        flex-wrap: wrap;
        padding-top: 12px;
    }
    .txt-size{
        width: 76px;
        margin: auto 0 ;
        padding-bottom: 10px;
        color: $a-gray-999999;
    }
    .sub-campaign-list{
        margin: 0;
        padding-right: 10px;
        padding-bottom: 10px;
        flex: none;
    }
    .sub-campaign-item{
        cursor: pointer;
        font-size: 16px;
        border: 1px solid;
        color: $a-black-333333;
        border-color: #4a4a4a;
        padding: 2px 10px;
        border-radius: 4px;
        position: relative;
        // margin-bottom: ;
        .text-uppercase{
            text-transform: uppercase
        }
        &.active {
            border: 1px solid;
            border-color: #f9a601;
            color: #f9a601;
        }
        .icon-select{
            position: absolute;
            bottom: -1px;
            right: -2px;
        }
    }
</style>
